import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getPusherOrderRowSelect = createAsyncThunk('pusher/getPusherOrderRowSelect',
  async (formData = {}, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/pusher/select-order-row', formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getPusherOrderRowSelect;
